<!-- @format -->

<ng-container *transloco="let t">
  <table class="fudis-table fudis-mt-md">
    <caption class="fudis-table__caption">{{ t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.PRICE_BREAKDOWN") }}</caption>

    @if (!showOnlySummary) {
      <tr>
        <th scope="row" class="fudis-table__cell fudis-table__cell__align__left">
          {{ t("OPEN_UNIVERSITY_CART.WIZARD.TEACHING.PRODUCTS_AMOUNT", { count: cart.items.length }) }}
        </th>
        <td class="fudis-table__cell fudis-table__cell__align__left">
          {{ cart.priceWithoutVat ?? zeroPrice | money }}
          @if (totalCredits) {
            | {{ totalCredits }} {{ t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.CREDITS_ABBR") }}
          }
        </td>
      </tr>
    }

    @if (isStudyVoucherPayment) {
      <tr>
        <th scope="row" class="fudis-table__cell fudis-table__cell__align__left">
          {{ t("OPEN_UNIVERSITY_CART.PAYMENT_TYPE.STUDY_VOUCHER_DISCOUNT") }}
        </th>
        <td class="fudis-table__cell fudis-table__cell__align__left"> - {{ cart.priceWithoutVat | money }} </td>
      </tr>
    }

    <tr>
      <th scope="row" class="fudis-table__cell fudis-table__cell__align__left">
        {{ t("OPEN_UNIVERSITY_CART.WIZARD.TEACHING.VAT", { percentage: cart.vatPercent ?? 0 }) }}
      </th>
      <td class="fudis-table__cell fudis-table__cell__align__left"> + {{ cart.vatTotal ?? zeroPrice | money }} </td>
    </tr>

    <tr>
      <th scope="row" class="fudis-table__cell fudis-table__cell__align__left" data-cy="cart-price-label">
        <strong> {{ t("OPEN_UNIVERSITY_CART.WIZARD.TEACHING.PAYMENT_AMOUNT") }} </strong>
      </th>
      <td class="fudis-table__cell fudis-table__cell__align__left" data-cy="cart-price-text">
        {{ isStudyVoucherPayment ? (zeroPrice | money) : (cart.priceTotal | money) }}
      </td>
    </tr>
  </table>
</ng-container>
